/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = parseInt(swexanVars.breakpoints.mobile_max);
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 const chrono = require('chrono-node');
 if ( imagesLoaded ) {
  imagesLoaded.makeJQueryPlugin( $ );
 }

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/*
 * Globals
 ***************************/
  /* Window */
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    var windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    var isMobile = ( windowWidth <= mobileBreakpoint );
    var mobileNavBreakpoint = parseInt(swexanVars.breakpoints.nav_min);
    var isMobileNavActive = ( windowWidth <= mobileNavBreakpoint );
  /* Navigation */
    var isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

    let smoother = false;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

const dateToString = (date) => {
  return (date.getDate() + '').padStart(2, '0') + '/' + ((date.getMonth() + 1) + '').padStart(2, '0') + '/' + date.getFullYear();
};

const dateToPublicString = (date) => {
  return ((date.getMonth() + 1) + '').padStart(2, '0') + '/' + (date.getDate() + '').padStart(2, '0') + '/' + date.getFullYear();
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, ScrollSmoother, Flip);

  smoother = ScrollSmoother.create({
    smooth: 1,               // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true,           // looks for data-speed and data-lag attributes on elements
    smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices),
    onFocusIn: () => {
      ScrollTrigger.refresh();
    }
  });

  /* Loading animation */
  if ( $('.swexan-loading-animation').length ) {
    const introTL = gsap.timeline({
      paused: true,
      repeat: false,
      onComplete: function(){
        $('.swexan-loading-animation').css({
          'visibility': 'hidden',
          'pointer-events': 'none'
        });
      }
    });

    introTL.to('#intro-top-monogram-mask path', {
      strokeDashoffset: 632,
      duration: 0.9,
      ease: 'power2.inOut'
    });

    introTL.to('#intro-bottom-monogram-mask path', {
      strokeDashoffset: 630,
      duration: 0.9,
      ease: 'power2.inOut'
    }, '-=0.5');

    introTL.to({}, {
      duration: 0.2
    });

    introTL.to('#intro-top-monogram-mask path', {
      strokeDashoffset: 316,
      duration: 0.6,
      ease: 'power2.inOut'
    });

    introTL.to('#intro-bottom-monogram-mask path', {
      strokeDashoffset: 945,
      duration: 0.6,
      ease: 'power2.inOut'
    }, '-=0.6');

    if ( isMobile ) {
      introTL.to('.swexan-loading-animation', {
        borderWidth: 8,
        duration: 1.1,
        ease: 'power2.inOut'
      }, '-=0.9')
    } else {
      introTL.to('.swexan-loading-animation', {
        borderWidth: 10,
        duration: 1.1,
        ease: 'power2.inOut'
      }, '-=0.9');
    }


    introTL.to('.swexan-loading-animation', {
      opacity: 0,
      duration: 1.2
    }, '-=0.4')

    introTL.play();
  }

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header__nav').length ) {
    const navIndicator = document.createElement('span');
    navIndicator.classList.add('site-header__nav-menu__indicator');
    const currentNavItem = document.querySelector('.site-header__nav-menu > .current-menu-item > a, .site-header__nav-menu > .current-menu-ancestor > a, .site-header__nav-menu > .current-menu-ancestor > button');
    if ( currentNavItem !== null ) {
      currentNavItem.appendChild(navIndicator);
      navIndicator.classList.add('active');
    } else {
      document.querySelector('#site-nav-list > li > a, #site-nav-list > li > button').appendChild(navIndicator);
    }

    const scrollWrap = document.querySelector('.site-header__nav-menu-wrap');
    const scrollContainer = document.querySelector('.site-header__nav-menu-container');

    const scrollMonitor = new ScrollableContainer(scrollWrap, {
      classTarget: scrollContainer,
      scrollType: 'horizontal',
      arrows: true,
      appendArrows: scrollContainer
    });

    const matchMediaArgs = {};
    matchMediaArgs['(min-width: ' + mobileNavBreakpoint + 'px)'] = () => {
      ScrollTrigger.create({
        trigger: '.site-inner',
        start: 'top top-=96',
        end: 'bottom top',
        toggleClass: {
          targets: '.site-header',
          className: 'scrolled'
        },
        onEnter: function() {
          $('.site-header__nav-toggle').css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          });

          gsap.to('.site-header__nav-toggle', {
            opacity: 1,
          });

          gsap.to('.site-header__nav-inner', {
            opacity: 0,
            onComplete: function() {
              $('.site-header__nav-inner').css({
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
            }
          });
        },
        onLeaveBack: function() {
          $('.site-header__nav-toggle').removeClass('active');
          $('.site-header__nav-toggle').attr('aria-expanded', 'false');

          gsap.to('.site-header__nav-toggle', {
            opacity: 0,
            onComplete: function() {
              $('.site-header__nav-toggle').css({
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
            }
          });

          $('.site-header__nav-inner').css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          });

          gsap.to('.site-header__nav-inner', {
            opacity: 1,
            borderColor: 'rgba(14, 18, 36, 0)',
            backgroundColor: 'rgba(255,255,255,0)'
          });

          // if ( $('.page-header__navigation-container').length ) {
          //   gsap.to('.page-header__navigation-container', {
          //     y: '0'
          //   })
          // }
        }
      });
    };


    ScrollTrigger.matchMedia(matchMediaArgs);

    $('.site-header__nav-inner__search-trigger').on('click', function(){
      $(this).toggleClass('active');
      if ( $(this).hasClass('active') ) {
        $('.site-header__nav-inner__search').css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });

        gsap.to('.site-header__nav-inner__search', {
          ease: 'expo.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          duration: 0.8,
          onComplete: function() {
            $('.site-header__nav-inner__search-form__input').focus();
          }
        });
      } else {
        gsap.to('.site-header__nav-inner__search', {
          ease: 'expo.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          duration: 0.8,
          onComplete: function() {
            $('.site-header__nav-inner__search').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      }
    }).on('keypress', handleKeypressADA);

    $('.site-header__nav-inner__search-dismiss').on('click', function(){
      $('.site-header__nav-inner__search-trigger').removeClass('active');
      gsap.to('.site-header__nav-inner__search', {
        ease: 'expo.inOut',
        clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
        onComplete: function() {
          $('.site-header__nav-inner__search').css({
            'visibility': 'hidden',
            'pointer-events': 'none'
          });

          $('.site-header__nav-inner__search-trigger').focus();
        }
      });

    });

    $('#site-nav-list > li > a, #site-nav-list > li > button').each(function() {
      $(this).on('mouseenter', function(){
        const state = Flip.getState(navIndicator);
        this.appendChild(navIndicator);
        navIndicator.classList.add('active');

        Flip.from(state, {
          absolute: true,
          duration: 0.6,
          ease: 'back.inOut',
          onEnter: elements => gsap.fromTo(elements, {opacity: 0, scaleX: 0}, {opacity: 1, scaleX: 1}),
          onLeave: elements => gsap.fromTo(elements, {opacity: 1, scaleX: 1}, {opacity: 0, scaleX: 0}),
        });
      }).on('focus', function(){
        $(this).trigger('mouseenter');
      });
    });

    $('.site-header__nav-inner').on('mouseleave', function(){
      const state = Flip.getState(navIndicator);

      if ( currentNavItem !== null ) {
        currentNavItem.appendChild(navIndicator);
      } else {
        navIndicator.classList.remove('active');
      }

      Flip.from(state, {
        absolute: true,
        duration: 0.6,
        ease: 'back.inOut',
        onEnter: elements => gsap.fromTo(elements, {opacity: 0, scaleX: 0}, {opacity: 1, scaleX: 1}),
        onLeave: elements => gsap.fromTo(elements, {opacity: 1, scaleX: 1}, {opacity: 0, scaleX: 0}),
      });
    });

    const navResizeAction = (updated) => {
      if ( updated ) {
        if ( isMobileNavActive ) {
          $('#site-nav').attr('role', 'dialog');
          $('#site-nav').attr('aria-modal', 'true');

          const searchEl = $('.site-header__nav-inner__search').get(0);
          searchEl.removeAttribute('role');
          searchEl.removeAttribute('aria-modal');

          const toggleEl = $('.site-header__nav-toggle').get(0);
          toggleEl.removeAttribute('aria-controls');
          toggleEl.removeAttribute('aria-expanded');
          $('.site-header__nav-menu .sub-menu').hide();
        } else {
          const navEl = $('#site-nav').get(0);
          navEl.removeAttribute('role');
          navEl.removeAttribute('aria-modal');

          $('.site-header__nav-inner__search').attr('role', 'dialog');
          $('.site-header__nav-inner__search').attr('aria-modal', 'true');

          $('.site-header__nav-toggle').attr('aria-controls', 'site-nav');
          $('.site-header__nav-toggle').attr('aria-expanded', 'false');
          $('.site-header__nav-menu .sub-menu').show();
          if ( window.scrollY < 96 ) {
            $('#site-nav').css({
              'visibility': 'visible',
              'pointer-events': 'auto'
            });
          }
        }
      }
    };

    navResizeAction(true);
    windowResizeActions.push(navResizeAction);

    const mobileNavContainer = $('.site-header__nav-inner');
    const mobileToggle = $('.site-header__nav-toggle');
    const mobileNavItems = $('#site-nav-list > li > a, #site-nav-list > li > button');
    const mobileDismiss = $('.site-header__nav-dismiss');
    const firstFocusableMenuElement = $(mobileNavContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    const firstFocusableSearchElement = document.querySelector('.site-header__nav-inner__search-form__input');
    const lastFocusableSearchElement = document.querySelector('.site-header__nav-inner__search-dismiss');

    if ( $(mobileNavContainer).find('.menu-item-has-children') ) {
      $(mobileNavContainer).find('.menu-item-has-children').each(function(){
        const toggle = $(this).children('a, button');
        const submenu = $(this).children('.sub-menu')

        let target = $(toggle).attr('aria-controls');
        let expanded = $(toggle).attr('aria-expanded');

        const toggleResizeAction = (updated) => {
          if ( updated ) {
            if ( isMobileNavActive ) {
              $(toggle).attr('aria-controls', target);
              $(toggle).attr('aria-expanded', 'false');
              expanded = false;
              submenu.attr('style', '');
            } else {
              $(toggle).get(0).removeAttribute('aria-controls');
              $(toggle).get(0).removeAttribute('aria-expanded');
            }
          }
        };
        toggleResizeAction(true);

        toggle.on('mouseenter', () => {
          if ( !isMobileNavActive ) {
            submenu.attr('style', '');
            const submenuRects = submenu.get(0).getClientRects();
            if  ( submenuRects[0].x < 0 ) {
              submenu.css({
                'left': 'calc(50% + ' + ( Math.abs( submenuRects[0].x ) + 10 ) + 'px)'
              });
            }
            // console.log(submenuRects);
          }
        });

        toggle.on('click', function(){
          if ( isMobileNavActive ) {
            expanded = expanded == 'true' ? 'false' : 'true';
            $(toggle).attr('aria-expanded', expanded);
            console.log(submenu);
            submenu.slideToggle();
          }
        }).on('keypress', handleKeypressADA);
      });
    }

    $('.site-header__nav-toggle').on('click', function(){
      $(this).toggleClass('active');
      if ( isMobileNavActive ) {
        $('#site-nav').get(0).scrollTo(0,0);

        const animDuration = 0.9;
        if ( $(this).hasClass('active') ) {
          $(mobileNavContainer).css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          });

          const menuTL = gsap.timeline({
            repeat: 0,
            paused: true,
            onComplete: function() {
              $(mobileNavContainer).focus();
            }
          });

          menuTL.to(mobileNavContainer, {
            duration: animDuration,
            ease: 'expo.inOut',
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
          });

          const numItems = $(mobileNavItems).length;
          $(mobileNavItems).each(function(index){
            const parent = $(this).parent();
            menuTL.to(parent, {
              opacity: 1,
              scale: 1,
              y: 0,
              duration: (animDuration / numItems) / 2
              }, (((animDuration / numItems) / 4) * index) + (animDuration / 2) );
          });

          menuTL.play();
        } else {
          const menuTL = gsap.timeline({
            repeat: 0,
            paused: true,
            onComplete: function() {
             $('.site-header__nav-inner').css({
               'visibility': 'hidden',
               'pointer-events': 'none'
             });
            }
          });

          const numItems = $(mobileNavItems).length;


          menuTL.to(mobileNavContainer, {
            duration: animDuration,
            ease: 'expo.inOut',
            clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)'
          });

          $(mobileNavItems).each(function(index){
            const parent = $(this).parent();
            menuTL.to(parent, {
              opacity: 0,
              scale: 1.1,
              y: -24,
              duration: (animDuration / numItems) / 2
            }, (((animDuration / numItems) / 4 ) * ((numItems - 1) - index)) );
          });

          menuTL.play();
        }
      } else {
        $(this).attr('aria-expanded', $(this).hasClass('active') ? 'true' : 'false');
        if ( $(this).hasClass('active') ) {
          $('.site-header__nav-inner').css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          });

          gsap.to('.site-header__nav-inner', {
            opacity: 1
          });

          gsap.from('.site-header__nav-inner-underlay', {
            height: 0,
            onStart: function() {
              $('.site-header__nav-inner-underlay').css({
                'visibility': 'visible',
                'pointer-events': 'auto'
              });
            }
          });
        } else {
          gsap.to('.site-header__nav-inner', {
            opacity: 0,
            onComplete: function() {
              $('.site-header__nav-inner').css({
                'visiblity': 'hidden',
                'pointer-events': 'none'
              });
            }
          });

          gsap.to('.site-header__nav-inner-underlay', {
            height: 0,
            onComplete: function() {
              gsap.set('.site-header__nav-inner-underlay', {
                clearProps: 'height'
              });
              $('.site-header__nav-inner-underlay').css({
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
            }
          });

          if ( $('.page-header__navigation-container').length ) {
            gsap.to('.page-header__navigation-container', {
              y: '0'
            })
          }
        }
      }
    }).on('keypress', handleKeypressADA);

    $(mobileDismiss).on('click', function(){
      if ( isMobileNavActive ) {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        $(mobileToggle).removeClass('active');
        $(mobileToggle).focus();
      }
    }).on('keypress', handleKeypressADA);

    $(mobileNavContainer).on('keydown', function(e){
      if ( isMobileNavActive ) {
        if ( e.key == 'Escape' ) {
          mobileDismiss.click();
        } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });

    $('.site-header__nav-inner__search').on('keydown', function(e){
      if ( !isMobileNavActive ) {
        if ( e.key == 'Escape' ) {
          lastFocusableSearchElement.click();
        } else if(e.target == firstFocusableSearchElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableSearchElement.focus();
        } else if(e.target == lastFocusableSearchElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableSearchElement.focus();
        }
      }
    });
  }

  if ( $('.booking-form').length ) {
    $('.booking-form').each(function(){
      const startDate = $(this).find('.booking-form__startdate-input');
      const startDateProxy = $(this).find('.booking-form__startdate-proxy');
      const startErr = startDate.siblings('.booking-form__date-err');

      const endDate = $(this).find('.booking-form__enddate-input');
      const endDateProxy = $(this).find('.booking-form__enddate-proxy');
      const endErr = endDate.siblings('.booking-form__date-err');

      const today = new Date();
      const minDate = new Date(2023, 5, 15);

      let starVal = false;
      let endVal = false;

      const maxDate = new Date( today.getFullYear() + 1, today.getMonth() + 1, 0 );

      $(startDate).datepicker({
        next: endDate,
        min: today > minDate ? dateToString(today) : dateToString(minDate),
        max: dateToString(maxDate),
        outputFormat: 'y-MM-dd',
        inputFormat: 'dd/MM/y'
      });

      $(startDate).on('change', function(){
        const dateparts = this.value.split('-');
        const date = new Date(parseInt(dateparts[0]), parseInt(dateparts[1]) - 1, parseInt(dateparts[2]));
        console.log(date);

        startVal = date;
        $(startDateProxy).val( dateToPublicString(date) );
        const proxy = startDateProxy.get(0);
        proxy.removeAttribute('aria-invalid');
        proxy.removeAttribute('aria-describedBy');
        const errSpan = $(startDateProxy).siblings('.booking-form__date-err');
        errSpan.fadeOut();
      });

      $(endDate).datepicker({
        previous: startDate,
        min: today > minDate ? dateToString(today) : dateToString(minDate),
        max: dateToString(maxDate),
        outputFormat: 'y-MM-dd',
        inputFormat: 'dd/MM/y'
      });

      $(endDate).on('change', function(){
        const dateparts = this.value.split('-');
        const date = new Date(parseInt(dateparts[0]), parseInt(dateparts[1]) - 1, parseInt(dateparts[2]));
        console.log(date);

        endVal = date;
        $(endDateProxy).val( dateToPublicString(date) );
        const proxy = endDateProxy.get(0);
        proxy.removeAttribute('aria-invalid');
        proxy.removeAttribute('aria-describedBy');
        const errSpan = $(endDateProxy).siblings('.booking-form__date-err');
        errSpan.fadeOut();
      });

      $(startDateProxy).on('change', function(){
        let rawVal = this.value;
        const parsed = chrono.parseDate( rawVal );
        const errSpan = $(this).siblings('.booking-form__date-err');

        console.log(parsed);

        if ( parsed !== null ) {
          const date = new Date(parsed);


          $(startDate).datepicker('setDate', date);
          this.removeAttribute('aria-invalid');
          this.removeAttribute('aria-describedBy');
          $(errSpan).fadeOut();
          this.value = dateToPublicString(date);
          startVal = date;
        } else {
          $(this).attr('aria-invalid', 'true');
          $(this).attr('aria-describedBy', errSpan.attr('id'));
          $(errSpan).text('Please enter a valid date');
          $(errSpan).fadeIn();

        }
      });

      $(endDateProxy).on('change', function(){
        let rawVal = this.value;
        const parsed = chrono.parseDate( rawVal );
        const errSpan = $(this).siblings('.booking-form__date-err');

        console.log(parsed);

        if ( parsed !== null ) {
          const date = new Date(parsed);


          $(endDate).datepicker('setDate', date);
          this.removeAttribute('aria-invalid');
          this.removeAttribute('aria-describedBy');
          $(errSpan).fadeOut();
          this.value = dateToPublicString(date);
          endVal = date;
        } else {
          $(this).attr('aria-invalid', 'true');
          $(this).attr('aria-describedBy', errSpan.attr('id'));
          $(errSpan).text('Please enter a valid date');
          $(errSpan).fadeIn();

        }
      });

      // remove empty inputs from submit
      $(this).on('submit', function(){
        $(this)
        .find('input[name]')
        .filter(function () {
            return !this.value;
        })
        .prop('name', '');
      });
    });
  }

  if ( $('.site-header__announcement').length ) {
    $('.site-header__announcement').each(function(){
      const announcement = $(this);
      const dismiss = $(this).find('.site-header__announcement-dismiss');

      $(dismiss).on('click', function(){
        const initialOffset = (isMobileNavActive ? 8 : 10) + announcement.outerHeight();

        gsap.fromTo('body', {
          '--layout-nav-offset': initialOffset + 'px'
        }, {
          '--layout-nav-offset': '0px',
          duration: 0.6,
          ease: 'power2.inOut'
        });

        gsap.to('.site-header__announcement', {
          // translate up -100% and --layout-site-border
          y: () => {
            const siteBorder = isMobileNavActive ? 8 : 10;
            const announcementHeight = announcement.outerHeight();
            return '-' + (announcementHeight + siteBorder) + 'px';
          },
          duration: 0.6,
          ease: 'power2.inOut',
          onComplete: function() {
            announcement.remove();
          }
        })
        // add cookie `wordpress_announcement_dismissed` with value `true` and expiration of 7 days
        const date = new Date();
        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = "wordpress_announcement_dismissed=true;" + expires + ";path=/";

      }).on('keypress', handleKeypressADA);
    });
  }

  if ( $('.site-footer__search-input').length ) {
    $('.site-footer__search-input').on('change', function(){
      if ( $(this).val() != '' ) {
        $(this).parent().addClass('has-input');
      } else {
        $(this).parent().removeClass('has-input');
      }
    });
  }

  if ( $('.page-header__navigation').length ) {
    const navIndicator = document.createElement('span');
    navIndicator.classList.add('page-header__navigation-menu__indicator');
    document.querySelector('.page-header__navigation-menu .current-menu-item a').appendChild(navIndicator);

    // ScrollTrigger.create({
    //   trigger: '.page-header__navigation-container',
    //   start: 'top top+=62',
    //   endTrigger: '#colophon',
    //   end: 'top bottom',
    //   pin: '.page-header__navigation',
    //   pinType: 'transform',
    //   pinSpacing: false,
    // });

    $('.page-header__navigation-menu a').each(function() {
      $(this).on('mouseenter', function(){
        const state = Flip.getState(navIndicator);
        this.appendChild(navIndicator);

        Flip.from(state, {
          absolute: true,
          duration: 0.6,
          ease: 'back.inOut',
          onEnter: elements => gsap.fromTo(elements, {opacity: 0, scaleX: 0}, {opacity: 1, scaleX: 1}),
          onLeave: elements => gsap.fromTo(elements, {opacity: 1, scaleX: 1}, {opacity: 0, scaleX: 0}),
        });
      }).on('focus', function(){
        $(this).trigger('mouseenter');
      });
    });

    $('.page-header__navigation-menu').on('mouseleave', function(){
      const state = Flip.getState(navIndicator);
      document.querySelector('.page-header__navigation-menu .current-menu-item a').appendChild(navIndicator);
      Flip.from(state, {
        absolute: true,
        duration: 0.6,
        ease: 'back.inOut',
        onEnter: elements => gsap.fromTo(elements, {opacity: 0, scaleX: 0}, {opacity: 1, scaleX: 1}),
        onLeave: elements => gsap.fromTo(elements, {opacity: 1, scaleX: 1}, {opacity: 0, scaleX: 0}),
      });
    });
  }
  /* END NAVIGATION SCRIPTS */

  /* ARCHIVE BLOCK SCRIPTS */
  if ( $('.archive-block').length ) {
    $('.archive-block').each(function(){
      const archiveBlock = $(this);
      const archiveFeed = $(this).find('.archive-block__feed');
      const archivePagination = $(this).find('.archive-block__pagination-container');

      const archiveFilterForm = $(this).find('.archive-block__header');
      const archiveSortInputs = $(this).find('.archive-block__sort-radio-input');
      const archiveSearchInput = $(this).find('.archive-block__search-input');
      const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

      const archiveFilterGroups = $(this).find('.archive-block__filter');


      const base = $(this).data('baseurl');
      let currentURL = $(this).data('currenturl');
      const initPage = $(this).data('page');
      const postType = $(this).data('posttype');
      const exclude = $(this).data('exclude');

      let updateArchive;
      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: 'default',
        postType: postType,
        search: false,
        exclude: exclude,
        filters: {}
      };

      if ( this.hasAttribute('data-postsper') ) {
        stateObj.postsPerPage = $(this).data('postsper');
      }

      if ( this.hasAttribute('data-cardargs') ) {
        stateObj.cardArgs = $(this).data('cardargs');
      }

      const updateURLFromFilters = () => {
        const baseurl = base[0] === '/' ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if ( stateObj.sort !== 'default' ) {
          url.searchParams.append('sort', 'sort-' + stateObj.sort);
        }

        if ( stateObj.search !== false ) {
          url.searchParams.append('search', stateObj.search);
        }

        if ( Object.keys(stateObj.filters).length ) {
          for ( const filterType in stateObj.filters ) {
            if ( Array.isArray(stateObj.filters[filterType]) ) {
              url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      if ( archiveFilterGroups.length ) {
        $(archiveFilterGroups).each(function() {
          const inputs = $(this).find('input');
          const indicator = document.createElement('span');
          indicator.classList.add('archive-block__filter-input__label-indicator');

          const mobileToggle = $(this).find('.archive-block__filter-toggle');
          const mobileDropdown = $(this).find('.archive-block__filter-list');

          mobileToggle.on('click', function(){
            if ( isMobile ) {
              $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true' );

              if ( $(this).attr('aria-expanded') == 'true' ) {
                $(mobileDropdown).css({
                  'visibility': 'visible',
                  'pointer-events': 'auto'
                });
                gsap.to(mobileDropdown, {
                  clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
                });
              } else {
                gsap.to(mobileDropdown, {
                  clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
                  onComplete: function(){
                    $(mobileDropdown).css({
                      'visibility': 'hidden',
                      'pointer-events': 'none'
                    });
                  }
                })
              }
            }
          }).on('keypress', handleKeypressADA);

          $(inputs).each(function(){
            const name = $(this).attr('name');
            const type = $(this).attr('type');
            const val = $(this).attr('value');

            if ( $(this).is(':checked') ) {
              const label = $(this).siblings('.archive-block__filter-input__label').get(0);
              label.appendChild(indicator);

              if ( type === 'radio' ) {
                stateObj.filters[ name ] = val;
              } else {
                if ( stateObj.filters.hasOwnProperty(name) ) {
                  stateObj.filters[ name ].push( val );
                } else {
                  stateObj.filters[ name ] = [ val ];
                }
              }
            }

            $(this).on('change', function(){
              if ( $(this).is(':checked') ) {
                const state = Flip.getState(indicator);
                const label = $(this).siblings('.archive-block__filter-input__label').get(0);
                label.appendChild(indicator);
                Flip.from(state, {
                  absolute: true,
                  duration: 0.6,
                  ease: 'back.inOut',
                });

                $(mobileToggle).find('.archive-block__filter-toggle__current').text( label.textContent );

                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  stateObj.filters[ name ].push( val );
                }
              } else if ( type === 'checkbox' ) {
                stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
              }
              updateURLFromFilters();

              if ( isMobile ) {
                $(mobileToggle).attr('aria-expanded', 'false');
                gsap.to(mobileDropdown, {
                  clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
                  onComplete: function(){
                    $(mobileDropdown).css({
                      'visibility': 'hidden',
                      'pointer-events': 'none'
                    });
                  }
                });
              }
            });
          });
        });
      }

      if ( archiveSortInputs.length ) {
        const toggle = $(this).find('.archive-block__sort-toggle');
        const dropdown = $(this).find('.archive-block__sort-dropdown');
        const toggleHint = $(toggle).find('.archive-block__sort-toggle__current');

        const toggleDropdown = (state) => {
          if ( state ) {
            $(dropdown).css({
              'visibility': 'visible',
              'pointer-events': 'auto'
            });

            gsap.to(dropdown, {
              clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
            });
          } else {
            gsap.to(dropdown, {
              clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
              onComplete: function(){
                $(dropdown).css({
                  'visibility': 'hidden',
                  'pointer-events': 'none'
                });
              }
            });
          }
        };

        $(toggle).on('click', function(){
          const oldState = $(this).attr('aria-expanded') == 'true';
          $(this).attr('aria-expanded', oldState ? 'false' : 'true');
          toggleDropdown(!oldState);
        }).on('keypress', handleKeypressADA);

        if ( $('.archive-block__sort-radio-input:checked' ).length ) {
          stateObj.sort = $('.archive-block__sort-radio-input:checked' ).data('sortkey');
        }

        $(archiveSortInputs).on('change', function(){
          stateObj.sort = $('.archive-block__sort-radio-input:checked' ).data('sortkey');
          $(toggle).attr('aria-expanded', 'false');
          toggleDropdown(false);
          updateURLFromFilters();
          $(toggleHint).text( $(this).next().text() );
        });
      }

      if ( archiveSearchInput.length ) {
        if ( archiveSearchInput.val() !== '' ) {
          stateObj.search = archiveSearchInput.val();
        }
      }

      if ( archiveSearchConfirm.length ) {
        archiveSearchConfirm.on('click', function(){
          const searchQuery = archiveSearchInput.val();
          if ( searchQuery !== '' ) {
            if ( stateObj.search !== searchQuery ) {
              stateObj.search = searchQuery;
            }

            updateURLFromFilters();
          } else {
            if ( stateObj.search !== false ) {
              stateObj.search = false;
              updateURLFromFilters();
            }
          }
        }).on('keypress', handleKeypressADA);
      }

      if ( archiveFilterForm.length ) {
        archiveFilterForm.on('submit', function(e){
          e.preventDefault();
          if ( archiveSearchConfirm.length ) {
            archiveSearchConfirm.trigger('click');
          }
        });
      }



      $(archivePagination).on('click', 'a', function(e){
        e.preventDefault();
        if ( ajaxIsLoading === false ) {
          const url = $(e.target).attr('href');
          let page = 1;
          const urlparts = url.split('?')[0].split('/');
          let parsedNum = false;
          for ( let i = urlparts.length - 1; i >= 0; i-- ) {
            if ( urlparts[ i ] != '' ) {
              const parsed = parseInt( urlparts[ i ] );
              if ( !isNaN(parsed) ) {
                parsedNum = parsed;
                break;
              }
            }
          }

          if ( parsedNum !== false ) {
            page = parsedNum;
          }

          console.log(page);


          stateObj.url = url;
          stateObj.page = page;

          updateArchive();
        }
      }).on('keypress', 'a', function(e){
        e.preventDefault();
        $(this).trigger('click');
      });

      const initState = stateObj;

      window.addEventListener('popstate', function(event){
        if ( Object.keys(event.state).length == 0 ) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });


      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass('loading');
        smoother.scrollTo(archiveBlock, true, 'top top+=136');

        if ( frompopstate === false ) {
          history.pushState(stateObj, '', stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude
        };

        if ( stateObj.search !== false ) {
          args.search = stateObj.search;
        } if ( stateObj.hasOwnProperty('postsPerPage') ) {
          args.postsPerPage = stateObj.postsPerPage;
        } if ( stateObj.hasOwnProperty('cardArgs') ) {
          args.cardArgs = stateObj.cardArgs;
        } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
          args.filters = stateObj.filters;
        }

        console.log(args);

        $.post(swexanVars.ajaxURL, {
          action: 'cmykpress_get_archive',
          args: args
        }, function(data) {
          console.log(data);
          try {
            const res = JSON.parse(data);
            const state = Flip.getState( archiveFeed.get(0).querySelector('li') );
            $(archiveFeed).html( res.results );
            $(archivePagination).html( res.pagination );

            Flip.from(state, {
              absolute: true,
              duration: 0.6,
              onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
              onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
            });
          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          $(archiveBlock).removeClass('loading');
          ajaxIsLoading = false;
        });
      };
    });
  }
  /* END ARCHIVE BLOCK SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  // gallery
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }

  if ( $('.masonry-gallery').length ) {
    $('.masonry-gallery').each(function() {
      console.log($(this));
      const thisRef = this;

      // smoother.kill();

      $(this).imagesLoaded(function(){
        var msnry = new Masonry( thisRef, {
          itemSelector: '.masonry-gallery__grid-item',
          columnWidth: '.masonry-gallery__sizer',
          gutter: 20,
          percentPosition: true
        });

        // photoswipe
        const leftArrowSVGString = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 200 125" width="100%" height="auto" style="overflow:visible" fill="none">  <path d="M12.9527 7.09877L0 6.69753V8.4465L12.9835 7.90123C11.6049 11.6358 8.2716 15 8.2716 15C10.8128 13.3436 15.823 7.87037 21.6358 7.52058V7.48971C15.823 7.12963 10.8128 1.76955 8.2716 0C9.55761 1.66667 11.7695 4.41358 12.9527 7.09877Z" fill="#0E1224" transform="scale(-5,5) translate(-40)" />  </svg>';

        const closeCrossButton = '<svg aria-hidden="true" class="pswp__icn-close" width="42" height="36" viewBox="0 0 42 36" style="overflow:visible" fill="none"> <path d="M1 32.8413C1 32.4017 1.06594 31.995 1.19782 31.6214C1.3297 31.2477 1.51927 30.9263 1.76655 30.657C2.01382 30.3878 2.31605 30.179 2.67322 30.0306C3.03039 29.8767 3.43427 29.7998 3.88486 29.7998C4.34644 29.7998 4.75306 29.8767 5.10474 30.0306C5.46192 30.1845 5.79986 30.385 6.11856 30.6323L5.72293 31.1763C5.44268 30.9455 5.15694 30.7669 4.86571 30.6405C4.57448 30.5142 4.24753 30.451 3.88486 30.451C3.53868 30.451 3.22821 30.5114 2.95346 30.6323C2.68421 30.7477 2.45617 30.9125 2.26934 31.1268C2.08251 31.3411 1.93964 31.5967 1.84073 31.8934C1.74182 32.1846 1.69237 32.5061 1.69237 32.8578C1.69237 33.2039 1.74182 33.5226 1.84073 33.8139C1.93964 34.1051 2.08251 34.3551 2.26934 34.5639C2.45617 34.7673 2.68421 34.9266 2.95346 35.042C3.22272 35.1574 3.52769 35.2151 3.86837 35.2151C4.25852 35.2151 4.60195 35.1464 4.89868 35.009C5.19541 34.8717 5.48939 34.6793 5.78062 34.4321L6.16802 34.9678C5.83832 35.2371 5.48939 35.4541 5.12123 35.619C4.75306 35.7838 4.3327 35.8663 3.86013 35.8663C3.42603 35.8663 3.03314 35.7921 2.68146 35.6437C2.32978 35.4953 2.02756 35.2865 1.77479 35.0173C1.52752 34.748 1.33519 34.4293 1.19782 34.0612C1.06594 33.693 1 33.2864 1 32.8413Z"  /> <path d="M10.6583 29.9317H11.3259V35.1327H14.4168V35.7344H10.6583V29.9317Z" /> <path d="M18.3436 32.8495C18.3436 32.4099 18.4123 32.006 18.5497 31.6379C18.687 31.2642 18.8794 30.9428 19.1266 30.6735C19.3794 30.3988 19.6816 30.1845 20.0333 30.0306C20.385 29.8767 20.7779 29.7998 21.212 29.7998C21.6461 29.7998 22.039 29.8767 22.3907 30.0306C22.7423 30.1845 23.0418 30.3988 23.2891 30.6735C23.5364 30.9428 23.7259 31.2642 23.8578 31.6379C23.9952 32.006 24.0639 32.4099 24.0639 32.8495C24.0639 33.2836 23.9979 33.6875 23.8661 34.0612C23.7342 34.4293 23.5446 34.748 23.2973 35.0173C23.05 35.281 22.7506 35.4898 22.3989 35.6437C22.0472 35.7921 21.6516 35.8663 21.212 35.8663C20.7779 35.8663 20.385 35.7921 20.0333 35.6437C19.6816 35.4898 19.3794 35.281 19.1266 35.0173C18.8794 34.748 18.687 34.4293 18.5497 34.0612C18.4123 33.6875 18.3436 33.2836 18.3436 32.8495ZM19.036 32.8495C19.036 33.2012 19.0854 33.5254 19.1843 33.8221C19.2887 34.1134 19.4344 34.3634 19.6212 34.5722C19.8135 34.781 20.0416 34.9458 20.3053 35.0667C20.5746 35.1821 20.874 35.2398 21.2037 35.2398C21.5334 35.2398 21.8329 35.1821 22.1022 35.0667C22.3714 34.9458 22.5995 34.781 22.7863 34.5722C22.9731 34.3634 23.116 34.1134 23.2149 33.8221C23.3193 33.5254 23.3715 33.2012 23.3715 32.8495C23.3715 32.4923 23.3193 32.1654 23.2149 31.8687C23.116 31.5719 22.9704 31.3164 22.778 31.1021C22.5912 30.8878 22.3632 30.723 22.0939 30.6076C21.8302 30.4867 21.5334 30.4262 21.2037 30.4262C20.8795 30.4262 20.5828 30.4867 20.3136 30.6076C20.0498 30.723 19.8218 30.8878 19.6294 31.1021C19.4426 31.3164 19.297 31.5719 19.1926 31.8687C19.0882 32.1654 19.036 32.4923 19.036 32.8495Z" /> <path d="M28.6437 34.2919C28.9294 34.5887 29.2234 34.8167 29.5257 34.9761C29.8334 35.1354 30.2015 35.2151 30.6301 35.2151C30.8499 35.2151 31.0505 35.1904 31.2318 35.1409C31.4187 35.0915 31.578 35.0228 31.7099 34.9349C31.8418 34.8414 31.9434 34.7288 32.0149 34.5969C32.0863 34.4595 32.122 34.3084 32.122 34.1436C32.122 33.9787 32.0918 33.8414 32.0314 33.7315C31.9764 33.6161 31.8802 33.5172 31.7429 33.4347C31.611 33.3523 31.4352 33.2809 31.2154 33.2204C30.9956 33.1545 30.7263 33.0885 30.4076 33.0226C30.0889 32.9567 29.8086 32.8825 29.5669 32.8001C29.3251 32.7121 29.1245 32.6077 28.9652 32.4868C28.8058 32.3605 28.6849 32.2121 28.6025 32.0418C28.5201 31.8659 28.4789 31.6571 28.4789 31.4153C28.4789 31.1681 28.5311 30.9455 28.6355 30.7477C28.7399 30.5444 28.8855 30.374 29.0723 30.2367C29.2591 30.0938 29.4789 29.9866 29.7317 29.9152C29.99 29.8383 30.2702 29.7998 30.5724 29.7998C31.0011 29.7998 31.383 29.874 31.7181 30.0224C32.0588 30.1652 32.3611 30.3548 32.6248 30.5911L32.2209 31.1268C31.9847 30.918 31.7264 30.7532 31.4461 30.6323C31.1659 30.5059 30.8747 30.4427 30.5724 30.4427C30.3691 30.4427 30.1823 30.4647 30.012 30.5087C29.8416 30.5526 29.696 30.6158 29.5751 30.6982C29.4542 30.7807 29.3608 30.8796 29.2949 30.995C29.2289 31.1104 29.196 31.2367 29.196 31.3741C29.196 31.5225 29.2207 31.6461 29.2701 31.745C29.3251 31.8439 29.4103 31.9319 29.5257 32.0088C29.6465 32.0802 29.8032 32.1434 29.9955 32.1984C30.1878 32.2533 30.4213 32.311 30.6961 32.3715C30.9434 32.4209 31.1934 32.4813 31.4461 32.5528C31.7044 32.6187 31.9352 32.7149 32.1385 32.8413C32.3473 32.9677 32.5149 33.1298 32.6413 33.3276C32.7732 33.5254 32.8391 33.7809 32.8391 34.0941C32.8391 34.3634 32.7842 34.6079 32.6743 34.8277C32.5644 35.042 32.4105 35.2261 32.2127 35.3799C32.0204 35.5338 31.7896 35.6519 31.5203 35.7344C31.2511 35.8168 30.9543 35.858 30.6301 35.858C30.1301 35.858 29.6905 35.7728 29.3113 35.6025C28.9377 35.4321 28.5695 35.1739 28.2069 34.8277L28.6437 34.2919Z"  /> <path d="M37.4746 35.7344V29.9317H41.4063V30.5334H38.1422V32.4704H41.0683V33.0556H38.1422V35.1327H41.4063V35.7344H37.4746Z" /> <path d="M1 1L41.4068 15.7069" stroke="white" /><path d="M41.4067 1L0.999956 15.7069" stroke="white" />  </svg>';

        const lightbox = new PhotoSwipeLightbox({
          gallery: '.masonry-gallery',
          children: 'a',
          arrowPrevSVG: leftArrowSVGString,
          arrowNextSVG: leftArrowSVGString,
          closeSVG: closeCrossButton,
          zoom: false,
          counter: false,
          pswpModule: PhotoSwipe,
        });

        lightbox.on('openingAnimationStart', () => {
          console.log('openingAnimationStart');
        });

        lightbox.on('openingAnimationEnd', () => {
          console.log('openingAnimationEnd');
        });

        lightbox.on('closingAnimationStart', () => {
          console.log('closingAnimationStart');
        });

        lightbox.on('closingAnimationEnd', () => {
          console.log('closingAnimationEnd');
        });

        $(thisRef).find('a').on('click', function(e){
        });

        lightbox.init();
      });
    });
  }

  // accordion
  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }

  if ( $('.gfield.is-date-field').length ) {
    $('.gfield.is-date-field').each(function(){
      const today = new Date();
      const minDate = new Date(2023, 5, 15);

      let datepickerIsOpen = false;

      const input = $(this).find('input[type="text"]');
      input.val( today > minDate ? dateToPublicString(today) : dateToPublicString(minDate) );
      input.datepicker({
        outputFormat: 'MM/dd/y',
        inputFormat: 'MM/dd/y',
        min: today > minDate ? dateToPublicString(today) : dateToPublicString(minDate),
        gainFocusOnConstruction: false
      });

      $(input).datepicker().on('opened', () => {
        datepickerIsOpen = true;
      });

      $(input).datepicker().on('closed', () => {
        datepickerIsOpen = false;
      });

      $(input).on('change', function(){
        if ( datepickerIsOpen === false ) {
          let rawVal = this.value;
          const parsed = chrono.parseDate( rawVal, today > minDate ? today : minDate, {forwardDate: true} );

          if ( parsed !== null ) {
            const date = new Date(parsed);

            this.value = dateToPublicString(parsed);
          } else {

          }
        }
      });
    });
  }
  /* END GUTENBERG SCRIPTS */

  /* SCROLL ANIMATIONS */
  if ( $('.wp-block-cover .wp-block-embed.is-provider-vimeo').length ) {
    $('.wp-block-cover .wp-block-embed.is-provider-vimeo').each(function(){
      $(this).addClass('has-js');
      const iframe = this.querySelector('iframe');
      const url = $(iframe).attr('src');
      const wrapper = this.querySelector('.wp-block-embed__wrapper');
      iframe.remove();
      const player = new Vimeo.Player(wrapper, {
        url: url,
        background: true,
        controls: false
      });

      player.setVolume(0);
      player.play();

      smoother.effects(wrapper, {
        speed: 'auto'
      });
    });
  }

  if ( $('.wp-block-cover__image-background.has-parallax').length ) {
    $('.wp-block-cover__image-background.has-parallax').each(function(){
      smoother.effects(this, {
        speed: 'auto'
      });
    });
  }

  if ( $('.page-header__image img').length ) {
    $('.page-header__image img').each(function(){
      smoother.effects(this, {
        speed: 'auto'
      });
    });
  }

  if ( $('.feed-block').length ) {
    $('.feed-block').each(function() {
      const articles = $(this).find('.content-card');



      if ( $(this).hasClass('cards-style-gradient-masonry') ) {
        gsap.set(articles, {
          opacity: 0
        });

        ScrollTrigger.batch(articles, {
          onEnter: batch => gsap.to(batch, {
            opacity: 1,
            stagger: {each: 0.15, grid: [1, 3]},
            overwrite: true,

          }),
          onLeaveBack: batch => gsap.to(batch, {
            opacity: 0,
            stagger: {each: 0.15, grid: [1, 3]},
            overwrite: true
          })
        });
      } else {
        gsap.set(articles, {
          opacity: 0,
          y: 96,
          scale: 0.95,
          transformOrigin: 'center top',
          backgroundSize: '100% 0'
        });

        ScrollTrigger.batch(articles, {
            onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, scale: 1, ease: 'power3.out', transformOrigin: 'center top', backgroundSize: '100% calc(100% - 0.7rem)', duration: 1.2, stagger: {each: 0.15, grid: [1, 3]}, overwrite: true}),
            onLeaveBack: batch => gsap.to(batch, {opacity: 0, y: 96, scale: 0.95, transformOrigin: 'center top', backgroundSize: '100% 0', ease: 'power3.out', duration: 0.6, stagger: {each: 0.15, grid: [1, 3]}, overwrite: true})
         });
      }


    });
  }

  if ( $('.image-with-text').length ) {
    $('.image-with-text').each(function(){
      const img = $(this).find('.image-with-text__image').get(0);

      gsap.set(img, {
        y: 120,
        scale: 0.8,
        opacity: 0
      });

      gsap.to(img, {
        y: 0,
        scale: 1,
        opacity: 1,
        scrollTrigger: {
          trigger: this,
          start: 'top bottom',
          end: 'top center',
          scrub: 2.5
        }
      });
    });
  }

  // generic scroll animations
  const toAnim = $('.animate-children > *, .page-content > *');
  if ( toAnim.length ) {
    toAnim.each(function(){
      if ( !$(this).hasClass('dont-animate') && !$(this).hasClass('wp-block-cover') ) {
        const thisRef = this;

        if ( $(this).hasClass('wp-block-image') ) {
          gsap.set(this, {
            y: 120,
            opacity: 0,
            scale: 0.8
          });

          gsap.to(this, {
            y: 0,
            scale: 1,
            opacity: 1,
            scrollTrigger: {
              trigger: this,
              start: 'top bottom',
              end: 'top center',
              scrub: 2.5
            }
          });
        } else {
          gsap.set(this, {
            y: 32,
            opacity: 0
          });

          ScrollTrigger.create({
            trigger: this,
            start: 'top bottom-=64',
            end: 'bottom top',
            onEnter: function() {
              gsap.to(thisRef, {
                y: 0,
                opacity: 1,
                ease: 'power3.out',
                duration: 1.2
              });
            },
            onLeaveBack: function() {
             gsap.to(thisRef, {
               y: 32,
               opacity: 0,
               ease: 'power3.out',
               duration: 0.6
             });
            }
          });
        }
      }
    });
  }

  const gform_information = {

  };

  $(document).bind('gform_post_render', function(){

    setTimeout(function(){
      ScrollTrigger.refresh();
    }, 600);


  });
  /* END SCROLL ANIMATIONS */
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  let oldNavState = isMobileNavActive;
  isMobile = ( windowWidth <= mobileBreakpoint );
  isMobileNavActive = ( windowWidth <= mobileNavBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile || oldNavState !== isMobileNavActive;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/
 function gutenbergSlickify(el) {
   const count = $(el).find('figure').length;

   const captions = [];

   $(el).find('figure').each(function(){
     if ( $(this).find('figcaption').length ) {
       $(this).addClass('has-caption');
       captions.push( $(this).find('figcaption').clone(true) );
       $(this).find('figcaption').remove();
     } else {
       captions.push('<div style="height:10px;"></div>');
     }
   });

   $(el).find('.blocks-gallery-item').each(function(){
     $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
   });

   $(el).find('.blocks-gallery-item__caption').each(function(){
     $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
   });

   $(el).addClass('slick-gallery-grid').removeClass('blocks-gallery-grid');

   // $(el).parent().addClass('slick-gallery').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> of <b>' + count +'</b></div></div>');

   $(el).removeClass('wp-block-gallery').wrap('<div></div>');
   const parent = $(el).parent();
   parent.addClass('slick-gallery').addClass('alignfull').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__inner"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">01</span></b> / <b class="page_count">0' + count +'</b></div><div class="slick-gallery-nav__captions-outer"><div class="slick-gallery-nav__captions"></div></div></div>');


   const nav = $(el).parent().find('.slick-gallery-nav');
   const captionsContainer = nav.find('.slick-gallery-nav__captions');
   for (let i = 0; i < captions.length; i++) {
     captionsContainer.append( captions[i] );
   }

   captionsContainer.slick({
     adaptiveHeight: true,
     arrows: false,
     swipe: false,
     fade: true
   });

   $(el).slick({
     adaptiveHeight: true,
     prevArrow: prevArrow,
     nextArrow: nextArrow,
     appendArrows: nav.find('.slick-gallery-nav__inner'),
     asNavFor: captionsContainer,
     centerMode: true,
     slidesToShow: 1,
     centerPadding: '20vw',
     arrowsPlacement: 'beforeSlides',
     responsive: [
       {
         breakpoint: 1600,
         settings: {
           centerPadding: '12vw'
         }
       },
       {
         breakpoint: 1024,
         settings: {
           centerPadding: '8vw'
         }
       },
       {
          breakpoint: 768,
          settings: {
            centerPadding: '30px'
          }
        }
     ]
   });

   $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
     nav.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
   });
 }

 // ***********  MASONRY.JS FULL PAGE GALLERY BLOCK  ***************

  var $gallery = $('.full-page-gallery').masonry({
    columnWidth: '.full-page-gallery__image',
    itemsSelector: '.full-page-gallery__image',
    gutter: 25,
    // percentPosition: true
    });
    $gallery.imagesLoaded().progress( function() {
      $gallery.masonry('layout');
    });


    class ScrollableContainer {
  constructor(scrollableNode, args = {}) {
    const {
      scrollType,
      scrollPadding = 32,
      classTarget = null,
      arrows = false,
      appendArrows = null
    } = args;

    this.scroller = scrollableNode;
    this.classTarget = classTarget && classTarget instanceof HTMLElement ? classTarget : this.scroller;
    this.scrollType = scrollType && ['horizontal', 'vertical'].includes(scrollType) ? scrollType : 'vertical';
    this.scrollPadding = typeof scrollPadding === 'number' ? scrollPadding : 32;
    this.arrows = typeof arrows === 'boolean' ? arrows : false;
    this.appendArrows = appendArrows && appendArrows instanceof HTMLElement ? appendArrows : this.classTarget;

    this.assessScroll();

    $(window).on('resize', (() => {
      this.assessScroll();
    }).bind(this));

    ScrollTrigger.create({
      scroller: this.scroller,
      horizontal: this.scrollType === 'horizontal',
      start: this.scrollPadding * -1,
      end: (() => {
        return this.scrollType === 'horizontal' ? this.scroller.scrollWidth - this.scroller.clientWidth : this.scroller.scrollHeight - this.scroller.clientHeight;
      }).bind(this),
      // markers: true,
      toggleClass: {
        targets: this.classTarget,
        className: 'can-scroll-positive'
      }
    })

    ScrollTrigger.create({
      scroller: this.scroller,
      horizontal: this.scrollType === 'horizontal',
      start: this.scrollPadding,
      end: (() => {
        return this.scrollType === 'horizontal' ? this.scroller.scrollWidth - this.scroller.clientWidth + this.scrollPadding : this.scroller.scrollHeight - this.scroller.clientHeight + this.scrollPadding;
      }).bind(this),
      // markers: true,
      toggleClass: {
        targets: this.classTarget,
        className: 'can-scroll-negative'
      }
    })

    if ( this.arrows !== null && this.arrows !== false ) {
      this.appendArrows.insertAdjacentHTML('afterbegin', prevArrow);
      this.appendArrows.insertAdjacentHTML('beforeend', nextArrow);

      this.nextArrow = this.appendArrows.querySelector('.slick-next');
      this.prevArrow = this.appendArrows.querySelector('.slick-prev');
      
      this.nextArrow.addEventListener('click', (e) => {
        e.preventDefault();
        const scrollAmount = this.scrollType === 'horizontal' ? this.scroller.clientWidth - this.scrollPadding : this.scroller.clientHeight - this.scrollPadding;
        console.log(this.scroller);
        if ( this.scrollType === 'horizontal' ) {
          gsap.to(this.scroller, {
            scrollTo: {
              x: this.scroller.scrollLeft + scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        } else {
          gsap.to(this.scroller, {
            scrollTo: {
              y: this.scroller.scrollTop + scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        }
      });

      this.prevArrow.addEventListener('click', (e) => {
        e.preventDefault();
        const scrollAmount = this.scrollType === 'horizontal' ? this.scroller.clientWidth - this.scrollPadding : this.scroller.clientHeight - this.scrollPadding;
        if ( this.scrollType === 'horizontal' ) {
          gsap.to(this.scroller, {
            scrollTo: {
              x: this.scroller.scrollLeft - scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        } else {
          gsap.to(this.scroller, {
            scrollTo: {
              y: this.scroller.scrollTop - scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        }
      });
    }
  }

  assessScroll() {
    this.isScrollable = this.scrollType === 'horizontal' ? this.scroller.scrollWidth > this.scroller.clientWidth : this.scroller.scrollHeight > this.scroller.clientHeight;
    console.log( this.scroller.scrollHeight, this.scroller.clientHeight, this.isScrollable );

    if ( this.isScrollable ) {
      this.classTarget.classList.add('is-scrollable');
    } else {
      this.classTarget.classList.remove('is-scrollable');
    }
  }
}